export const readBase64 = (file: File): Promise<string> => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    return new Promise((resolve, reject) => {
        reader.onload = () => {
            const dataUrl = reader.result as string;
            const base64String = dataUrl.split(',')[1];
            resolve(base64String);
        };

        reader.onerror = (event) => {
            reject(event);
        };
    });
}
